import { render, staticRenderFns } from "./EmbedButton.vue?vue&type=template&id=23c5d316&"
import script from "./EmbedButton.vue?vue&type=script&lang=js&"
export * from "./EmbedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports